import React, { Component } from 'react';
import axios from 'axios';
import Footer from './Footer';
import '../css/About.css';

class About extends Component {
  render() {
    return (
      <div className="staticParent">
        <div className="staticWidth">
          <div className="staticHeader">
            {this.state.about && this.state.about.title}
          </div>
          <div
            className=" staticBody faded"
            dangerouslySetInnerHTML={{
              __html: this.state.about && this.state.about.body,
            }}
          />
          <div className="ourTeam faded">The Team</div>
          <div className="teamList">
            {this.state.team.map((member, i) => (
              <div className="faded flex flex-justify" key={member.id}>
                <div className="teamName">
                  {member.photo && (
                    <img
                      alt="Project team"
                      className={
                        (i === this.state.team.length - 1 ? 'mb0 ' : '') +
                        'teamPhoto'
                      }
                      src={
                        'https://res.cloudinary.com/gates/image/upload/c_fill,h_200,w_200/' +
                        member.photo
                      }
                    />
                  )}
                </div>
                <div
                  className={
                    (i === this.state.team.length - 1 ? 'mb0 ' : '') + 'teamBio'
                  }
                >
                  <div dangerouslySetInnerHTML={{ __html: member.body }} />
                </div>
              </div>
            ))}
          </div>
          <Footer />
        </div>
      </div>
    );
  }

  constructor(props) {
    super();
    this.state = {
      about: null,
      team: [],
    };
  }

  componentDidMount() {
    this.getAbout();
    this.getTeam();
  }

  getAbout() {
    axios
      .get('/page/about')
      .then(result => {
        if (Object.keys(result.data).length !== 0)
          this.setState({ about: result.data });
      })
      .catch(error => {
        console.log(error);
      });
  }

  getTeam() {
    axios
      .get('/member')
      .then(result => {
        if (result.data.length) this.setState({ team: result.data });
      })
      .catch(error => {
        console.log(error);
      });
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.jsx